import { type RouteObject } from 'react-router-dom';

import { firstAllowed, requirePermissions } from '@/app/requirePermissions';
import { PagePermissions } from '@/models/pagePermissions';
import { Permissions } from '@/models/permission';

export const settingsRoute: RouteObject = {
  path: 'settings',
  children: [
    {
      // Not always 'general': an importer holding neither sandboxes:edit nor
      // languages:edit belongs on Import, which is the page they can use.
      index: true,
      loader: firstAllowed([
        { to: 'general', oneOf: PagePermissions.settingsGeneral },
        { to: 'import', oneOf: PagePermissions.settingsImport },
      ]),
    },
    {
      path: 'general',
      // The page also gates its two sections individually, so a viewer holding one of
      // the codes sees only what they may edit.
      loader: requirePermissions({ oneOf: PagePermissions.settingsGeneral }),
      lazy: () => import('./general'),
    },
    {
      path: 'import',
      // On the parent: one gate for the wizard and all of its steps.
      loader: requirePermissions({ oneOf: PagePermissions.settingsImport }),
      children: [
        {
          path: '',
          lazy: () => import('./import/index'),
        },
        // One code per wizard, matching what admin-api's router now demands
        // (BR-RBAC-36): the create/edit pairs these used to ask for would deny
        // users the API would let through.
        {
          path: 'items',
          // Also the bundle and currency importer — one items:import covers all
          // three (BR-RBAC-34).
          loader: requirePermissions({ oneOf: [Permissions.items.import] }),
          lazy: () => import('./import/item'),
        },
        {
          path: 'snapshot',
          loader: requirePermissions({ oneOf: [Permissions.store.import] }),
          lazy: () => import('./import/snapshot'),
        },
        {
          path: 'gifts',
          loader: requirePermissions({ oneOf: [Permissions.gifts.import] }),
          lazy: () => import('./import/gift'),
        },
        {
          path: 'season-passes',
          loader: requirePermissions({
            oneOf: [Permissions.seasonpass.import],
          }),
          lazy: () => import('./import/seasonPass'),
        },
      ],
    },
  ],
};
